import { JobSiteState } from '../types';

import { DEFAULT_ROWS_PER_PAGE } from 'app/constants/paginate';

export const jobSiteState: JobSiteState = {
  JobSiteList: [],
  limit: DEFAULT_ROWS_PER_PAGE,
  pageIndex: 0,
  totalRecordCount: 0,
  sortBy: '-id',
  sortField: 'id',
  recordId: '',
  deleteDialog: false,
  jobSiteToDelete: [],
  jobSiteToUpdate: [],
  createModal: false,
  updateModal: false,
  jobSiteImages: [],
  csvUpload: false,
  columns: [
    {
      id: 'id',
      field: 'id',
      header: 'Jobsite ID',
      order: 0,
      isVisible: true,
      option: { width: '160px', sortBy: 'event-type' },
    },
    {
      id: 'name',
      field: 'name',
      header: 'Name',
      order: 0,
      isVisible: true,
      option: { width: '160px', sortBy: 'event-type' },
    },
    {
      id: 'street',
      field: 'street',
      header: 'Street',
      order: 1,
      isVisible: true,
      option: { width: '160px', sortBy: 'event-type' },
    },
    {
      id: 'city',
      field: 'city',
      header: 'City',
      order: 2,
      isVisible: true,
      option: { width: '160px', sortBy: 'event-type' },
    },
    {
      id: 'state',
      field: 'state',
      header: 'State',
      order: 3,
      isVisible: true,
      option: { width: '160px', sortBy: 'event-type' },
    },
    {
      id: 'postal_code',
      field: 'postalCode',
      header: 'Zip',
      order: 4,
      isVisible: true,
      option: { width: '160px', sortBy: 'event-type' },
    },
    {
      id: 'note',
      field: 'note',
      header: 'Note',
      order: 5,
      isVisible: true,
      option: { width: '100px' },
    },
    {
      id: 'action',
      field: 'action',
      header: 'Action',
      order: 6,
      isVisible: true,
      option: { width: '100px' },
    },
    {
      id: 'selection',
      field: 'selection',
      order: 7,
      isVisible: true,
      option: { width: '30px' },
    },
  ],
};
